import * as React from "react";
import Result from "antd/es/result";
import Link from "antd/es/typography/Link";
import Paragraph from "antd/es/typography/Paragraph";
import Button from "antd/es/button";

export interface ErrorDisplayProps {
    orderId: string;
    retry?: {
        method: () => void;
        label: string;
    };
}

export const ErrorDisplay: React.FunctionComponent<ErrorDisplayProps> = (props) => {
    return (
        <Result
            title="Transfer failed"
            extra={(
                <>
                    <Paragraph>
                        Please contact us at our <Link className="ErrorLink" href="mailto:liberstake@gmail.com">support e-mail</Link> for further info.
                    </Paragraph>
                    <Paragraph>
                        Append this ID to your e-mail: {props.orderId}
                    </Paragraph>
                    {props.retry && (
                        <Button onClick={props.retry.method}>
                            {props.retry.label}
                        </Button>
                    )}
                </>
            )}
            status="error"
        />
    );
};
